export default function setSizeChart(size) {
  const screen = window.innerWidth;

  if (screen > 800) {
    if (size === 'md') return [95, 60, 150, 80];
    return [20, 60, 300, 80];
  }
  return [100, 60, 140, 80];
}
